
































































































import { defineComponent } from 'vue';
import { f7 } from 'framework7-vue';

import bus from '@/bus';
import { catalogStoreMapper } from '../store';
import { appStoreMapper } from '@/store/appstore';

export default defineComponent({
  name: 'CatalogPaymentPopup',
  data: () => ({
    status: 'success',
  }),
  mounted() {
    bus.$on('catalog:payment:status:popup', this.openPopup);
  },
  beforeDestroy() {
    bus.$off('catalog:payment:status:popup', this.openPopup);
  },
  computed: {
    ...appStoreMapper.mapGetters(['isPWA']),
    ...catalogStoreMapper.mapState(['orderStatus']),
  },
  methods: {
    openPopup() {
      f7.popup.open('.payment-popup');
      this.openPayUrl();
    },
    openPayUrl() {
      if (this.orderStatus?.additionalAction) {
        window.open(this.orderStatus.additionalAction.params.url, '_blank');
      }
    },
    closePopup() {
      f7.popup.close('.payment-popup');
    },
  },
});
